<article class="bob-modal">
  <h3 class="margin-bottom padding-bottom">
    {{isAgencySource ? "" : isGenAgencySource ? "PREFERRED " : isStdAgencySource ? "REPORTING " : ""}}
    {{modalContent.title}}
  </h3>
  <section class="margin-bottom">
    <mat-radio-group [(ngModel)]="needSelect">
      <mat-radio-button value="false">{{modalContent.includeAll || 'Include All'}}
      </mat-radio-button>
      <br>
        <mat-radio-button value="true">{{modalContent.selectAgencies || 'Select Agencies'}}</mat-radio-button>
      </mat-radio-group>
    </section>


    @if (needSelect) {
      <section>
        @if (needSelect === 'true') {
          <section>
            <div>
              {{all.count}} out of {{agencyList.length}}
            </div>
            <!-- <mat-form-field appearance="fill" class="full-width">
            <mat-label>Find Agency Name</mat-label>
            <input matInput type="text" placeholder="Find Agency Name" [(ngModel)]="all.nameFilter"
              class="full-width" />
            </mat-form-field> -->
            <label class="margin-left">
              <mat-checkbox [(ngModel)]="all.selectAll" (change)="selectAll()">
                @if (!all.selectAll) {
                  <span>{{modalContent.selectAll}}</span>
                }
                @if (all.selectAll) {
                  <span> {{modalContent.deselectAll}}</span>
                }
              </mat-checkbox>
            </label>
            <div class="scrollable">
              @for (agency of agencyList; track agency) {
                <div>
                  <!-- filter:all.nameFilter  -->
                  <mat-checkbox [(ngModel)]="checkBoxModel[agency.agencyId]" (change)="checkChange()" required>
                  {{agency.agencyName }}</mat-checkbox>
                </div>
              }
            </div>
            <div class="warning">
              Selecting an Agency is required.
            </div>
            <div data-ng-show="all.count" class="margin-left">
              <a href="javascript:" data-ng-click="clearChecks()" class="active-link">Clear</a>
            </div>
            <!-- <div data-error-handler="all"></div> -->
          </section>
        }
      </section>
    }



    <section class="{{needSelect =='true' && 'modal-btn-container' || ''}}">
      <div class="pull-right">
        <button mat-flat-button class="secondary" (click)="closeModal()">{{modalContent.cancel}}</button>
        <button mat-flat-button class="primary" type="submit"
        (click)="downloadReport()">{{modalContent.download}}</button>
      </div>
    </section>


  </article>